import { formatTargetPrice } from '../../Utils/formatTargetPrice';
import React, { useState, useEffect } from 'react';
import {
  ChevronDown,
  ChevronUp,
  Target as TargetIcon,
  TrendingUp,
  ArrowDown,
  ArrowUp,
  PieChart,
  Globe,
  Tag,
  BarChart2,
  Plus
} from 'react-feather';

import CompanyLogos from '../../components/CompanyLogos';
import './Target.css';

import { useTranslation } from "react-i18next";

export default function Target({ data, selectedCodes, onCodeSelected, onCodeRemoved, onCodeStatusChange, currentRemovedCodeActive }) {

  const { t, i18n } = useTranslation();

  const [isExpanded, setIsExpanded] = useState(false);
  const [isSelected, setIsSelected] = useState(selectedCodes.includes(data.shortName));

  const toggleCard = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (onCodeStatusChange && currentRemovedCodeActive === data.shortName) {
      selectTarget();
    }
  }, [onCodeStatusChange]);

  const selectTarget = () => {
    setIsSelected(!isSelected);
    !isSelected ? onCodeSelected(data.shortName) : onCodeRemoved(data.shortName);
  };

  return (
    <div className="target-container">
      <div className={`target-card ${isSelected ? "target-card-selected" : ""}`}>

        <div className="target-top-row">
          <div className="target-rank-badge">
            {data.rank || ""}
          </div>

          <div className="target-name-area">
            <p className="name-symbol">
              {data.shortName} <span>({data.symbol})</span>
            </p>
          </div>

          <div className="targets-logo-area">
            <CompanyLogos symbol={data.symbol} />
          </div>

          <button type="button" className="expand-btn top-expand-btn" onClick={toggleCard}>
            {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </button>
        </div>

        <div className="target-middle-row">
          <div className="target-metric-box target-price-box">
            <TargetIcon size={34} />
            <div className="metric-content">
              <span className="metric-label">{t("target.targetPrice")}</span>
              <strong className="metric-value primary-value">
                ${formatTargetPrice(data.newPrice)}
              </strong>
            </div>
          </div>

          <div className="target-metric-box">
            <TrendingUp size={28} />
            <div className="metric-content">
              <span className="metric-label">{t("search.lastRecordedPrice")}</span>
              <strong className="metric-value">
                ${data.currentPrice ?? "n/a"}
              </strong>
            </div>
          </div>

          <div className="target-metric-box">
            {Number(data.pricePercent) >= 0 ? <ArrowUp size={30} /> : <ArrowDown size={30} />}
            <div className="metric-content">
              <span className="metric-label">{Number(data.pricePercent) < 0 ? t("top10.percentDownside") : t("top10.percentUpside")}</span>
              <strong className={`metric-value ${Number(data.pricePercent) >= 0 ? "positive" : "negative"}`}>
                {data.pricePercent ?? "n/a"}%
              </strong>
            </div>
          </div>
        </div>

        <div className="target-actions">
          <button
            type="button"
            onClick={selectTarget}
            className={isSelected ? "selected-text" : "select-text"}
          >
            <Plus size={17} />
            {isSelected ? t("target.selected") : t("target.selectToCompare")}
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="target-expanded">
          <div className="expanded-item">
            <div className="expanded-icon">
              <PieChart size={34} />
            </div>
            <div>
              <span style={{marginLeft: "0px"}}>{t("target.percentDividend")}</span>
              <strong>{data.propertyCalculatedDividend ?? "n/a"}</strong>
            </div>
          </div>

          <div className="expanded-item">
            <div className="expanded-icon">
              <Globe size={34} />
            </div>
            <div>
              <span style={{marginLeft: "0px"}}>{t("target.country")}</span>
              <strong>{data.country === "CAD" ? "🇨🇦 Canada" : "🇺🇸 USA"}</strong>
            </div>
          </div>

          <div className="expanded-item">
            <div className="expanded-icon">
              <Tag size={34} />
            </div>
            <div>
              <span style={{marginLeft: "0px"}}>{t("target.symbol")}</span>
              <strong>{data.symbol ?? "n/a"}</strong>
            </div>
          </div>

          <div className="expanded-item">
            <div className="expanded-icon">
              <BarChart2 size={34} />
            </div>
            <div>
              <span style={{marginLeft: "0px"}}>{t("target.psRatio")}</span>
              <strong>{data.ps ?? "n/a"}</strong>
            </div>
          </div>
        </div>
      )}
    </div>
  );

}
